import React from 'react';
import { Tab, TabList } from '@fluentui/react-components';
import { SPEC_OPTIONS } from './swaggerPageConfig';
import { useIsAdmin } from '../hooks/useIsAdmin';

function SwaggerSpecTabs({ className, specMode, onSpecModeChange }) {
  const isAdmin = useIsAdmin();
  const visibleOptions = SPEC_OPTIONS.filter((option) => isAdmin || option.value !== 'internal');

  return (
    <TabList
      className={className}
      selectedValue={specMode}
      onTabSelect={(_, data) => onSpecModeChange(data.value)}
    >
      {visibleOptions.map((option) => (
        <Tab
          key={option.value}
          value={option.value}
        >
          {option.label}
        </Tab>
      ))}
    </TabList>
  );
}

export default SwaggerSpecTabs;